(function() {
    'use strict';

angular.module('MyDirectives', [])

/* Used to capture images from the device's camera
* and resize them using given dimensions and quality
* <input type="file" capture="camera" accept="image/*"
	id="photoAddFile" image="imageBrowsed"
onfilechange="imageChanged(data)"
maxwidth="{{width}}" maxheight="{{height}}" quality="{{quality}}"
imagetype="image/jpeg" >
*/
.directive('image', function($q) {
'use strict'

var URL = window.URL || window.webkitURL;

return {
	restrict: 'A',
	scope: {
		/*image: '=',*/
		maxwidth: '@?',
		maxheight: '@?',
		quality: '@?',
		imagetype: '@?',
		onfilechange: '&'
	},
	link: function postLink(scope, element, attrs, ctrl) {
		var onFileChangeCallback = scope.onfilechange;
		var onFileFailureCallback = scope.onfileerror;
        var filename = "";
		var options;

		var getOptions = function() {
			var options = {
				maxWidth: parseFloat(scope.maxwidth) || 1024,
				maxHeight: parseFloat(scope.maxheight) || 768,
				quality: parseFloat(scope.quality) || 0.8,
				imageType: scope.imagetype || 'image/jpeg',
				canvas: true
			};
			return options;
		}

		var whenError = function(errorMessage) {
			scope.$apply(function() {
				if (typeof(onFileFailureCallback) == 'function') {
					//to pass data in the message, we need to have an object with attrs named as in
					//the html part, eg  onfilechange="imageChanged(data)"
					onFileFailureCallback({
						err: errorMessage
					});
				}
			});
		}

		var whenReady = function(img) {
			if (!(img.src || img instanceof HTMLCanvasElement)) {
				whenError('Loading image file failed');
			} else {
				var data = img.src || img.toDataURL(options.imageType, options.quality);
				var imageResult = {
					dataURL: data,
                    fileName : filename,
					fileType: options.imageType
				};
				scope.$apply(function() {
					if (typeof(onFileChangeCallback) == 'function') {
						//to pass data in the message, we need to have an object with attrs named as in
						//the html part, eg  onfilechange="imageChanged(data)"
						onFileChangeCallback({
							data: imageResult
						});
					}
				});
			}
		}

		element.bind('change', function(evt) {
			evt.preventDefault();
			//e = e.originalEvent;
			var target = evt.dataTransfer || evt.target;
			var files = target && target.files;
			if (files) {
				var file;
				options = getOptions(); //read latest settings
				for (var i = 0; i < files.length; i++) {
					file = files[i];
                    filename = file.name;
					//start by get metadata, to autoset the orientation of the image
					loadImage.parseMetaData(file,
						//when metadata are ready, use them and then load image
						function(data) {
							if (data.exif) {
								options.orientation = data.exif.get('Orientation');
							}
							if (!loadImage(file, whenReady, options)) {
								whenError('Your browser does not support capturing images.');
							}
						}
					);
				}
			}
		});
	}
};
})

})();